export default __webpack_public_path__ + "static/media/(8)-Suizo.b6f7357e.jpg";